import { mapDashboardDetailRows } from "web_myplann/Dashboard/Utils/dashboardDetailRows";
import type {
	ClientPropertyItemResponseDTO,
	PortfolioListItemResponseDTO,
	PortfolioListReportingSummaryResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";

export const useDashboardDetailRows = (
	portfolios: PortfolioListItemResponseDTO[] | undefined,
	properties: ClientPropertyItemResponseDTO[] | undefined,
	reportingData: PortfolioListReportingSummaryResponseDTO[] | undefined,
) => {
	const { t } = useResource();

	return {
		rows: mapDashboardDetailRows(portfolios, properties, reportingData, t),
	};
};
